module.exports = __webpack_public_path__ + "static/media/deskfix_reference.24404b97.png";